import {
  SorensenDiceSimilarity,
  DefaultTextParser,
  ConsoleLogger,
  AbsoluteSummarizerConfig,
  Summarizer
} from "ts-textrank";

const sim = new SorensenDiceSimilarity();
//Only one text parser available a this moment
const parser = new DefaultTextParser();

//Do you want logging?
const logger = new ConsoleLogger();

//Damping factor. See "How it works" for more info.
const d = 0.85;

//Get sentences in the order that they appear in text:
const sorting = Summarizer.SORT_OCCURENCE;

const config = new AbsoluteSummarizerConfig(75, sim, parser, d, sorting);
const summarizer = new Summarizer(config, logger);

export function sum(text) {
  const summary = summarizer.summarize(text, "en");
  return summary;
}
